'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contains = exports.contains = function contains(bit, value) {
  return (bit & value) !== 0;
};

var distance = exports.distance = function distance(a, b) {
  return Math.sqrt(a * a + b * b);
};

var copyCSSStyles = exports.copyCSSStyles = function copyCSSStyles(style, target) {
  // Edge does not provide value for cssText
  for (var i = style.length - 1; i >= 0; i--) {
    var property = style.item(i); // Safari shows pseudoelements if content is set

    if (property !== 'content') {
      target.style.setProperty(property, style.getPropertyValue(property));
    }
  }

  return target;
};

var SMALL_IMAGE = exports.SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';